export enum TEMPLATE_STATUS {
  APPROVED = "APPROVED",
  DISABLED = "DISABLED",
  FLAGGED = "FLAGGED",
  PENDING = "PENDING",
  DRAFT = "DRAFT",
  REJECTED = "REJECTED",
  PENDING_DELETION = "PENDING_DELETION",
  IN_REVIEW = "IN REVIEW",
  PAUSED = "PAUSED",
  ACTIVE = "ACTIVE",
  LIBRARY = "LIBRARY",
}

export enum CHANNELS {
  WHATSAPP = "whatsapp",
  INSTAGRAM = "instagram",
  TIKTOK = "tiktok",
  MESSENGER = "messenger",
  EMAIL = "email",
  MESSAGE = "message",
  GMAIL = "gmail",
  LIVECHAT = "livechat",
  GBM = "gbm",
  WEBPUSH = "webpush",
  FACEBOOK = "facebook",
  /** Not being used heavily as This is not being considered as a channel */
  SMS_INTERNATIONAL = "message_international",
}

export enum TEMPLATE_MANAGEMENT_TABS {
  ALL = "All",
  WHATSAPP = "WhatsApp",
  EMAIL = "Email",
  MESSAGE = "SMS",
  WEB_PUSH = "WebPush",
}
export interface TEMPLATE_COMPONENT_EXAMPLE {
  header_handle?: string[];
  body_text?: string[][];
}

export interface TEMPLATE_BUTTON {
  type: string; //can be updated with enum in future
  text: string;
}

export type HEADER_FORMAT = "IMAGE" | "VIDEO" | "DOCUMENT" | "TEXT" | "NONE";

export interface TEMPLATE_COMPONENT {
  type: "HEADER" | "BODY" | "BUTTONS" | "FOOTER" | "limited_time_offer";
  format?: HEADER_FORMAT;
  text?: string;
  html?: string;
  buttons?: TEMPLATE_BUTTON[];
  example?: TEMPLATE_COMPONENT_EXAMPLE;
}

export enum TEMPLATE_CATEGORY {
  MARKETING = "MARKETING",
  order = "order",
  ORDER = "ORDER",
  TRANSACTIONAL = "TRANSACTIONAL",
}

export enum CHANNEL_TYPE {
  WHATSAPP = "whatsapp",
  INSTAGRAM = "instagram",
  TIKTOK = "tiktok",
  EMAIL = "email",
  SMS = "message",
  WEBPUSH = "webpush",
  RCS = "rcs",
}

export interface TEMPLATE {
  templateId: string;
  storeId: string;
  name: string;
  label: string;
  language: string;
  category: TEMPLATE_CATEGORY;
  channelTemplateId: string;
  components: TEMPLATE_COMPONENT[];
  createdBy: string;
  createdAt: number | string;
  channel: string;
  templateCategory: string;
  isDraft?: boolean;
  isArchive?: boolean;
  mapping: {
    body?: string[];
    header?: string[];
    buttons?: string[];
  };
  status: TEMPLATE_STATUS_TYPE;
  htmlContentUrl?: string;
  content?: string;
  actionType?: string;
  isCarouselType?: boolean;
  htmlContentWithoutProductVarUrl?: string;
  // Per quick-reply config, keyed by button text; kept off the Meta components.
  qrbPayload?: {
    [buttonText: string]: {
      flowId?: string;
      flowName?: string;
      isPreSalesAgent?: boolean;
    };
  };
}

export type TEMPLATE_STATUS_TYPE =
  | "APPROVED"
  | "ACTIVE"
  | "DISABLED"
  | "FLAGGED"
  | "PENDING"
  | "DRAFT"
  | "REJECTED"
  | "PENDING_DELETION"
  | "PAUSED"
  | "LIBRARY"
  | "IN REVIEW";

export type templatePlaceHolder = {
  default_value: string;
  placeHolder: string;
  title: string;
};

export type templateVariable = {
  editable: boolean;
  variableName: string;
  variableVal?: string;
  editableDefaultValues?: string | null;
  idx: number;
};

export type CreateTemplateType = {
  /** Data */
  headerType: HEADER_TYPES;
  headerAssetLink?: string | null;
  headerAssetName?: string | null;
  headerText?: string;

  headerVariables: templateVariable[];
  bodyVariables: templateVariable[];

  bodyText?: string;
  bodyTextRaw?: string;

  footerText?: string;

  actionsType: ACTIONS_TYPES;

  quickReply: {
    btnTexts?: Array<string>;
  };
  ctaBtn: {
    phoneNumber?: {
      isChecked?: boolean;
      btnText?: string;
      phoneNumber?: string;
    };
    websiteLinkBtn?: {
      isChecked?: boolean;
      btnText?: string;
      linkOpens?: string;
      placeholder?: string;
    };
  };

  meta: {
    name: string;
    category?: string;
    subCategory?: string;
    language?: string;
    templateId?: string;
  };

  mode: "edit" | "create";
  alreadyAsADraft?: boolean;
  /** UI  */
  initialLoading: boolean;

  error: {
    modalError?: string;
    header?: string;
    body?: string;
    footer?: string;
    quickReply?: Array<string | null>;
    meta?: {
      name?: string;
    };
    ctaBtn?: {
      phoneNumber: {
        btnText: string;
        link: string;
      };
      websiteLink: { btnText: string; link: string };
    };
  };

  /** DATA DUMP */
  buttonPlaceholders?: templatePlaceHolder[];
};

export enum HEADER_TYPES {
  NONE = "NONE",
  TEXT = "TEXT",
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  DOCUMENT = "DOCUMENT",
}

export enum ACTIONS_TYPES {
  NONE = "NONE",
  CTA_BTN = "CTA_BTN",
  QUICK_RELPY = "QUICK_REPLY",
}

export enum STATUS {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  DISABLED = "DISABLED",
  FLAGGED = "FLAGGED",
}

export type TemplateVariableMapping = {
  body: string[];
  buttons: string[];
  header: string[];
  footer: string[];
};
